import { pathOr } from 'ramda';
import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query';
import { windowExists } from '@classity-edtech/ui-base';
import { SEO_CONTENT } from '../store/actionTypes';
import { pageQuery, variable } from '../utils/contentTypeQueries';
import { ContentVariable, PageContent } from './models/seo';

export const seoContent = createApi({
  reducerPath: SEO_CONTENT,

  baseQuery: graphqlRequestBaseQuery({
    url: `${pathOr('', ['graphqlService', 'url'], windowExists?.__UI_CONFIG__)}`,
    prepareHeaders: headers => {
      headers.set(
        'Authorization',
        `Bearer ${(windowExists?.localStorage as any).getItem('token')}`,
      );
      headers.set('x-ctt-source-project', `${windowExists?.__UI_CONFIG__.project}`);

      return headers;
    },
  }),

  tagTypes: ['SeoContent'],

  endpoints: builder => ({
    getPageContent: builder.query<PageContent, ContentVariable>({
      query: ({ contentType, tag }) => ({
        document: gql`
          ${pageQuery}
        `,
        variables: variable({ contentType, tag }),
      }),

      transformResponse: (response: any) => {
        const data = response?.entries?.items?.[0]?.fields;

        return {
          seo: data?.seo,
          header: data?.header,
          footer: data?.footer,
          sections: data?.sections,
        };
      },
    }),
  }),
});

export const { useGetPageContentQuery } = seoContent;
